import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { LockKeyhole } from "lucide-react";
import { PASSWORD_RULES_TEXT, validatePassword } from "../utils/password";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    const strengthError = validatePassword(password);
    if (strengthError) return setError(strengthError);
    if (password !== confirm) return setError("Les deux mots de passe ne correspondent pas.");
    if (!token) return setError("Lien de réinitialisation invalide.");

    setLoading(true);
    try {
      await api.post("/auth/password/reset", { token, new_password: password });
      setMessage("Mot de passe modifié. Tu peux maintenant te connecter.");
      setTimeout(() => navigate("/login"), 1800);
    } catch (err) {
      setError(err?.response?.data?.detail || "Impossible de réinitialiser le mot de passe.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12">
      <div className="card p-8 max-w-md w-full">
        <div className="w-12 h-12 rounded-xl bg-emerald-100 flex items-center justify-center mb-4">
          <LockKeyhole className="w-6 h-6 text-brand-green" />
        </div>
        <h1 className="font-heading text-3xl font-black mb-2">Nouveau mot de passe</h1>
        <p className="text-gray-600 text-sm mb-6">Choisis un nouveau mot de passe sécurisé.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label mb-1 block">Nouveau mot de passe</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input" placeholder="••••••••" />
            <p className="text-xs text-gray-500 mt-1">{PASSWORD_RULES_TEXT}</p>
          </div>
          <div>
            <label className="label mb-1 block">Confirmer le mot de passe</label>
            <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="input" placeholder="••••••••" />
          </div>
          {message && <p className="rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-700 text-sm p-3">{message}</p>}
          {error && <p className="rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm p-3">{error}</p>}
          <button disabled={loading} className="btn-primary w-full justify-center">
            {loading ? "Modification..." : "Modifier mon mot de passe"}
          </button>
          <Link to="/login" className="btn-ghost w-full justify-center">Retour connexion</Link>
        </form>
      </div>
    </div>
  );
}
